import React from 'react';
import classnames from 'classnames/bind';
import * as documentActions from "../../../actions/documents";

export default class ListDocuments extends React.Component {
    /**
     * 0 = Regular document
     * 1 = Accountancy document
     */

    download = (url, row)=>{
        this.props.dispatch(documentActions.downloadDocument(url, row.basename));
    };

    downloadCanceled = (url,row) =>{
        this.props.dispatch(documentActions.downloadCanceledDocument(url,row.basename));
    };

    handleCancel = (url,row) =>{
        this.props.dispatch(documentActions.cancelDocuments(this.props.fog.id,row.type,false));
    };

    render() {
        return (
            <ul className="document-list">
                {this.props.documents.map((row, index) => {
                    let title = row.basename;
                    //title = title.substring(0, title.indexOf('_')) + "...";
                    title = title.substring(0, title.indexOf('.pdf'));
                    title = title.replace(this.props.fogReference + '-', '');

                    if (title.length === 0) {
                        return null;
                    }

                    return (
                        <li key={index}>
                            {(!row.canceled)?<span><button onClick={() => this.handleCancel(row.url, row)} className="document-cancel-button">cancel</button>&nbsp;&nbsp;</span> : null}
                            <button onClick={() => {
                                if(row.canceled){
                                    this.downloadCanceled(row.url, row)
                                } else {
                                    this.download(row.url, row);
                                }
                            }}
                            className={classnames({"canceled": row.canceled})}
                            title={row.basename}>{title}</button>
                            &nbsp;/&nbsp;
                            <button onClick={() => {
                                if(row.canceled){
                                    this.downloadCanceled(row.accountancyUrl, row);
                                } else {
                                    this.download(row.accountancyUrl, row);
                                }
                            }}
                                    className={classnames({"canceled": row.canceled})} title={row.basename}>accounting
                            </button>
                        </li>
                    )
                }
                )}
            </ul>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/fog/costInvoice/ListDocuments.js